/**
 * Widget that will convert a section of <h1> and children elements into an accordion.
 *
 * See https://app.assembla.com/spaces/styletread/wiki/Accordion_Static_Block
 */
define([
    'jquery'
], function($) {
    'use strict';
     $.widget('munro.accordion', {
        options: {
            accordionContainerSelector: '',
            autoOpenFirstAccordion: false,
            headingSelector: 'h3'
        },
         _create: function() {
            var $pdpAccordionContainer = $(this.options.accordionContainerSelector);
             if ($pdpAccordionContainer.length > 0) {
                $pdpAccordionContainer.addClass("munro-accordion");
                this._initHandlers();
                this._processAccordion();
            }
        },
         /**
         * Initialised the handlers for the accordion
         *
         * @returns null
         */
        _initHandlers: function() {
            var MunroAccordion = this;
             var $pdpAccordionContainer = $(this.options.accordionContainerSelector);
            $pdpAccordionContainer.on("click", ".accordion-toggle", MunroAccordion._handlerToggleAccordion);
        },
         /**
         * Process the elements in the accordion container, standardizing their structure
         *
         * @return null
         */
        _processAccordion: function() {
            var MunroAccordion = this;
             var $pdpAccordionContainer = $(MunroAccordion.options.accordionContainerSelector);
             //Find all of the headings in the accordion container - these will be the titles for each individual accordion
            var $accordionHeadings = $pdpAccordionContainer.find(MunroAccordion.options.headingSelector);
             //An array of sections for the accordion
            var sections = [];
             //Loop through all headings and find the 'next' elements that aren't another heading.
            $accordionHeadings.each(function(index, heading) {
                var section = {};
                var $heading = $(heading);
                section.heading = $heading.text();
                section.content = $heading.nextUntil(MunroAccordion.options.headingSelector);
                 //Delete the heading (which we'll recreate)
                $heading.remove();
                 if (section.content.length === 0) {
                    return;
                }
                 //Detach the content (which we'll reattach)
                section.content.detach();
                 sections.push(section);
            });
             //For each of the sections, append them to the accordion contain in <section>'s
            $.each(sections, function(index, section) {
                var $section = $('<section></section>');
                var $heading = $('<div class="accordion-title accordion-toggle">'+section.heading+'</div>');
                var $content = $('<div class="accordion-content u-visually-hidden"></div>');
                 $content.append(section.content);
                $section.append($heading);
                $section.append($content);
                $pdpAccordionContainer.append($section);
            });
             if (MunroAccordion.options.autoOpenFirstAccordion) {
                $pdpAccordionContainer.find("section:first-child").find(".accordion-toggle").click();
            }
        },
         /**
         * Handle showing/hiding the accordion section content
         *
         * @return null
         */
        _handlerToggleAccordion: function() {
            var $accordionSectionTitle = $(this);
            $accordionSectionTitle.toggleClass('open').next().toggleClass('u-visually-hidden');
        }
    });
     return $.munro.accordion;
});